<template lang="pug">
v-container(fluid fill-height class="tw-pb-0 tw-px-0")
  v-row(no-gutters align-self="stretch")
    v-col(class="tw-relative")
      div(class="tw-px-4")
        v-row(class="pt-2 pb-4")
          v-col
            template(v-if="this.action !== 'add'")
              span(class=" tw-text-2xl text-secondary tw-font-bold ") {{ $t('Settings.Common.editOffice') }}
            template(v-else)
              span(class=" tw-text-2xl text-secondary tw-font-bold ") {{ $t('Settings.Common.addOffice') }}
        v-form(ref="form" v-model="valid" lazy-validation @keyup.navtive.enter="valid && submit($event)")
          v-row(no-gutters)
            v-col
              v-text-field(
                v-model="office.name"
                outlined
                hide-details
                :rules="rules.officeName"
                :label="$t('Common.name')"
              )
          v-row(dense)
            v-col
              v-text-field(v-model="office.phone" outlined hide-details label="Phone")
            v-col
              v-text-field(
                v-model="office.email"
                outlined
                :rules="rules.email"
                hide-details
                :label="$t('Common.email')"
              )
          v-row(dense)
            v-col(class="tw-pt-0")
              gmap-autocomplete(v-model="address" class="IntroInput" selectFirstOnEnter @place_changed="setAddress")
                template(v-slot:input="slotProps")
                  v-text-field(
                    v-model="address"
                    :placeholder="$t('Settings.Common.searchAddress')"
                    ref="input"
                    hide-details
                    v-on:listeners="slotProps.listeners"
                    color="primary"
                  )
          v-row(dense)
            v-col(cols="9")
              v-text-field(
                v-model="office.address_street"
                :disabled="!address"
                outlined
                hide-details
                :label="$t('Common.street')"
              )
            v-col(cols="3")
              v-text-field(
                v-model="office.address_street_number"
                :disabled="!address"
                outlined
                hide-details
                :label="$t('Common.number')"
              )
          v-row(dense v-if="office.address_extended_address")
            v-col
              v-text-field(
                v-model="office.address_extended_address"
                :disabled="!address"
                outlined
                hide-details
                :label="$t('Common.extendedAddress')"
              )
          v-row(dense)
            v-col
              v-text-field(
                v-model="office.addresss_block"
                :disabled="!address"
                outlined
                hide-details
                :label="$t('Common.block')"
              )
            v-col
              v-text-field(
                v-model="office.address_floor"
                :disabled="!address"
                outlined
                hide-details
                label="Floor"
                :label="$t('Common.floor')"
              )
            v-col
              v-text-field(
                v-model="office.address_door"
                :disabled="!address"
                outlined
                hide-details
                :label="$t('Common.door')"
              )
          v-row(dense)
            v-col
              v-text-field(
                v-model="office.address_city"
                :disabled="!address"
                outlined
                hide-details
                :label="$t('Common.city')"
              )

            v-col
              v-text-field(
                v-model="office.address_state"
                :disabled="!address"
                outlined
                hide-details
                :label="$t('Common.state')"
              )

          v-row(dense class="tw-pb-8")
            v-col
              v-text-field(
                v-model="office.address_country"
                :disabled="!address"
                outlined
                hide-details
                :label="$t('Common.country')"
              )

            v-col
              v-text-field(
                v-model="office.address_zip_code"
                :disabled="!address"
                outlined
                hide-details
                :label="$t('Common.zipCode')"
                label="Zip Code"
              )

      v-row(
        no-gutters
        align="center"
        justify="end"
        class=" tw-mt-6 tw-px-4  tw-bg-indigo-lighten-4 tw-bg-opacity-25 tw-self-end tw-w-full  tw-bottom-0 "
      )
        v-col(cols="auto")
          v-btn(
            x-small
            text
            elevation="0"
            :ripple="false"
            @click="$emit('close')"
          )
            span(class=" tw-text-xs tw-pt-4 tw-text-gray-darken-1") {{ $t('Common.cancel') }}
        v-col(cols="auto")
          v-btn(depressed :loading="loading" @click="submit" color="rgba(94,129,244,0.80)")
            span(class="tw-font-bold") {{ action == 'add' ? $t('Common.add') : $t('Common.save') }}
</template>

<script>
export default {
  props: ['action', 'item'],
  data() {
    return {
      loading: false,
      office: {},
      valid: true,
      address: null,
      rules: {
        officeName: [(v) => !!v || 'Please enter the office name'],
        email: [
          //(v) => !!v || 'Please enter your email',
          (v) => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid',
        ],
      },
    };
  },
  mounted() {
    if (this.action !== 'add') {
      this.office = JSON.parse(JSON.stringify(this.item));
    }
  },
  methods: {
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (this.action == 'add') {
          this.loading = true;
          this.$store
            .dispatch('offices/add', this.office)
            .then((response) => {
              this.$store.dispatch('offices/list');
              this.loading = false;
              this.$emit('close');
            })
            .catch((error) => {
              commit('SET_ERROR', error, { root: true });
            });
        }
        if (this.action == 'edit') {
          this.loading = true;
          this.$store
            .dispatch('offices/update', this.office)
            .then((response) => {
              this.$store
                .dispatch('offices/list')
                .then((response) => {
                  this.loading = false;
                  this.$emit('close');
                })
                .catch((error) => {
                  commit('SET_ERROR', error, { root: true });
                });
            })
            .catch((error) => {
              commit('SET_ERROR', error, { root: true });
            });
        }
      }
    },
    setAddress(address) {
      this.office.address_street = '';
      this.office.address_street_number = '';
      this.office.address_extended_address = '';
      this.office.address_city = '';
      this.office.address_state = '';
      this.office.address_country = '';
      this.office.address_zip_code = '';
      this.address = address.formatted_address;
      this.key += this.key;
      this.office.address_latitude = address.geometry.location.lat();
      this.office.address_longitude = address.geometry.location.lng();
      for (let i = 0; i < address.address_components.length; i++) {
        const componentType = address.address_components[i].types[0];
        switch (componentType) {
          case 'street_number':
            this.office.address_street_number = address.address_components[i].long_name;
            break;

          case 'route':
            this.office.address_street = address.address_components[i].long_name;
            break;

          case 'sublocality_level_1':
            this.office.address_extended_address = address.address_components[i].long_name;
            break;

          case 'locality':
            this.office.address_city = address.address_components[i].long_name;
            break;

          case 'administrative_area_level_1':
            this.office.address_state = address.address_components[i].long_name;
            break;

          case 'country':
            this.office.address_country = address.address_components[i].long_name;
            break;

          case 'postal_code':
            this.office.address_zip_code = address.address_components[i].long_name;
            break;
        }
      }
    },
    cancel() {
      this.$emit('close');
    },
  },
};
</script>
